export default "__VITE_ASSET__BF2Qpn1o__"